
export default {
  props: {
    content: Object // element, description, subtitle
  }
}
